import { Box, Typography } from '@mui/material';
import { useDialog } from 'hooks/common';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SparkButton, SparkDialog } from 'sharedComponents/UI';
import { useStatusBarStore } from 'stores';
import { Error } from 'components/SVG';

function SparkRunErrorModal() {
  const navigate = useNavigate();
  const { open, closeDialog, openDialog } = useDialog();
  const isError = useStatusBarStore(
    React.useCallback((state) => state.isError, [])
  );
  const resetStatusConfig = useStatusBarStore(
    React.useCallback((state) => state.resetStatusConfig, [])
  );

  const resetFormStatusConfig = () => {
    resetStatusConfig();
  };

  const resetStatusBarStore = useStatusBarStore(
    React.useCallback((state) => state.resetStatusBarStore, [])
  );

  React.useEffect(() => {
    if (isError) {
      openDialog();
    } else {
      closeDialog();
    }
  }, [closeDialog, isError, openDialog]);

  const handleRetry = () => {
    resetFormStatusConfig();
  };

  const handleCancelClick = () => {
    resetStatusBarStore();
    navigate('/dashboard');
  };
  return (
    <SparkDialog
      open={open}
      onClose={closeDialog}
      title=''
      hideTitle={true}
      hideCloseButton={true}
      sx={{ '& .MuiPaper-root': { minWidth: '30rem' } }}
    >
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        flexDirection='column'
        gap={2}
        padding={2}
      >
        <Error width='100px' height='100px' />
        <Typography
          color={(theme) => theme.palette.grey[800]}
          fontFamily='Mont-semibold'
          variant='h4'
          marginTop={2}
        >
          Error
        </Typography>
        <Typography color={(theme) => theme.palette.grey[800]}>
          Something went wrong
        </Typography>
      </Box>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        gap={2}
        padding={2}
      >
        <SparkButton
          onClick={handleCancelClick}
          variant='outlined'
          sx={{
            height: '55px',
            borderRadius: '4px',
            padding: '0px 30px',
          }}
        >
          cancel
        </SparkButton>
        <SparkButton
          variant='contained'
          onClick={handleRetry}
          sx={{
            height: '55px',
            borderRadius: '4px',
            padding: '0px 30px',
          }}
        >
          Retry
        </SparkButton>
      </Box>
    </SparkDialog>
  );
}

export default SparkRunErrorModal;
